var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pagina-construccion',{attrs:{"nombreApartado":"Disposiciones CONAC","enlace":_vm.urlServe+'informacion-interes/armonizacion-contable/doctos-aprobados.asp'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }